import React from 'react'
import { TypographyProps, SxProps, Typography } from '@mui/material'
import { Trans } from 'react-i18next'

export interface LabelProps extends TypographyProps {
  label?: string
  translateLabel?: boolean

  required?: boolean
  sxProps?: SxProps
}
function Label(props: LabelProps) {
  const { label, required, translateLabel = false, sxProps, ...rest } = props
  return (
    <Typography
      fontSize={18}
      sx={{ color: 'rgba(0, 0, 0, 0.6)', ...sxProps }}
      {...rest}
    >
      {translateLabel ? (
        label ? (
          <Trans i18nKey={label} />
        ) : (
          `${label} `
        )
      ) : label ? (
        label
      ) : undefined}
      {` `}
      {required ? (
        <Typography component="span" display="inline-block" color="error">
          {` (*)`}
        </Typography>
      ) : null}
    </Typography>
  )
}

export default Label
